// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3Fa-5","title":"ClientReferral_title__2uVRe","itemText":"ClientReferral_itemText__zXaCT"};